import I18n from 'I18n';
import { useEffect, useState } from 'react';
import { InputGroup } from 'foundations-components/transitional/components/InputGroup';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { Select } from 'foundations-components/transitional/components/Select';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { Form } from 'foundations-components/transitional/components/Form';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { syntheticEvent } from 'foundations-components/transitional/utils/SyntheticEvent';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { ALLOWED_UTM_PARAMETERS, defaultUtmParameters, getDisplayValue, getFullUrl, getProtocol, getUrlBase, getUtmParameters, getUtmUrlInputValidationMessage, mergeUtmParameters } from '../../utils/urlUtils';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const defaultProtocolValue = 'https://';
export default function FilterOperatorUtmUrlInput(props) {
  const {
    disabled,
    error,
    value,
    onBlur,
    onChange,
    inputUse
  } = props;
  const isError = error.get('error');
  const errorMessage = error.get('message');
  const initialProtocol = getProtocol(value.urlBase) || defaultProtocolValue;
  const [protocol, setProtocol] = useState(!disabled ? initialProtocol : defaultProtocolValue);
  const [urlDomain, setUrlDomain] = useState(!disabled ? getDisplayValue(value.urlBase) : '');
  const [utmParameters, setUtmParameters] = useState(!disabled ? Object.assign({}, value.utmParameters) : Object.assign({}, defaultUtmParameters));
  useEffect(() => {
    if (disabled) {
      setProtocol(defaultProtocolValue);
      setUrlDomain('');
      setUtmParameters(Object.assign({}, defaultUtmParameters));
    } else if (value) {
      setProtocol(getProtocol(value.urlBase) || defaultProtocolValue);
      setUrlDomain(getDisplayValue(value.urlBase));
      setUtmParameters(Object.assign({}, value.utmParameters));
    }
  }, [disabled, value]);
  const handleProtocolChange = evt => {
    const newProtocol = evt.target.value;
    const newValue = getFullUrl(urlDomain, newProtocol);
    onChange(syntheticEvent({
      urlBase: newValue,
      utmParameters
    }));
    setProtocol(newProtocol);
  };
  const handleDomainChange = evt => {
    const {
      target: {
        value: currentValue
      }
    } = evt;
    const nextProtocol = getProtocol(currentValue) || protocol || defaultProtocolValue;
    setProtocol(nextProtocol);
    const nextDisplayValue = getDisplayValue(currentValue);
    setUrlDomain(nextDisplayValue);
    return onChange(syntheticEvent({
      urlBase: getFullUrl(nextDisplayValue, nextProtocol),
      utmParameters
    }));
  };
  const handleParameterChange = (id, evt) => {
    const {
      target: {
        value: evtValue
      }
    } = evt;
    utmParameters[id] = evtValue;
    return onChange(syntheticEvent({
      urlBase: getFullUrl(urlDomain, protocol),
      utmParameters
    }));
  };
  const handleFixClick = () => {
    const newDomain = getUrlBase(urlDomain);
    const newUtmParameters = getUtmParameters(getFullUrl(urlDomain, protocol));
    return onChange(syntheticEvent({
      urlBase: getFullUrl(newDomain, protocol),
      utmParameters: mergeUtmParameters(newUtmParameters, utmParameters)
    }));
  };
  const getUtmBlock = (label, id) => {
    return /*#__PURE__*/_jsxs(TFlex, {
      align: "baseline",
      justify: "between",
      direction: "row",
      marginBlock: "200",
      children: [/*#__PURE__*/_jsx(Text, {
        typography: "body-100",
        children: label
      }), /*#__PURE__*/_jsx(FormControl, {
        "aria-label": id,
        children: /*#__PURE__*/_jsx(TextInput, {
          onBlur: () => {
            if (!disabled && onBlur) {
              onBlur();
            }
          },
          onChange: evt => handleParameterChange(id, evt),
          value: utmParameters[id],
          disabled: disabled,
          use: inputUse
        })
      })]
    }, id);
  };
  return /*#__PURE__*/_jsxs(Form, {
    children: [/*#__PURE__*/_jsxs(InputGroup, {
      required: true,
      use: "itemLeft",
      disabled: disabled,
      marginBlock: "200",
      children: [/*#__PURE__*/_jsx(FormControl, {
        "aria-label": I18n.text('customerDataFiltersUI.customerDataFilters.FilterOperatorInput.ariaLabel'),
        children: /*#__PURE__*/_jsx(Select, {
          buttonUse: inputUse === 'on-dark' ? 'form-on-dark' : undefined,
          defaultValue: defaultProtocolValue,
          onChange: handleProtocolChange,
          options: [{
            text: 'https://',
            value: 'https://'
          }, {
            text: 'http://',
            value: 'http://'
          }],
          value: protocol
        })
      }), /*#__PURE__*/_jsx(FormControl, {
        "aria-label": I18n.text('customerDataFiltersUI.customerDataFilters.FilterOperatorInput.ariaLabel'),
        error: !disabled && isError,
        children: /*#__PURE__*/_jsx(TextInput, {
          onBlur: () => {
            if (!disabled && onBlur) {
              onBlur();
            }
          },
          onChange: handleDomainChange,
          value: urlDomain,
          use: inputUse
        })
      })]
    }), /*#__PURE__*/_jsx(FormControl, {
      "aria-label": I18n.text('customerDataFiltersUI.customerDataFilters.FilterOperatorInput.ariaLabel'),
      error: !disabled && isError,
      validationMessage: !disabled && isError ? /*#__PURE__*/_jsxs(_Fragment, {
        children: [errorMessage, ' ', getUtmUrlInputValidationMessage(urlDomain, utmParameters, handleFixClick)]
      }) : null,
      children: /*#__PURE__*/_jsx(_Fragment, {
        children: ALLOWED_UTM_PARAMETERS.map(param => getUtmBlock( /*#__PURE__*/_jsx(FormattedMessage, {
          message: `customerDataFiltersUI.customerDataFilters.FilterOperatorUtmUrlInput.parameters.${param}`
        }), param))
      })
    })]
  });
}